<template>
	<div class="category-animation-5-bg abs">
		<!--<transition name="fade-long">
			<div v-if="withFade" class="category-animation-5-bg__fade"></div>
		</transition>-->
		<video autoplay
			   muted
			   loop
			   playsinline
			   class="anim-fade-in"
			   @loadeddata="withFade=false">
			<source src="@/assets/animations/5/bg.mp4" type="video/mp4">
		</video>
	</div>
</template>

<script>
	export default {
		name: "category-animation-5-bg",
		components: {},
		data: () => {
			return {
				withFade: false,
			}
		},
	}
</script>

<style lang="scss">
	.category-animation-5-bg {
		top: 38%;
		width: 800px;
		height: 280px;

		video {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

</style>